import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import Loading from './components/utils/Loading';
import MainApp from './components/main_screens/main_app';
import Login from './components/main_screens/login';
import {base} from './base';
// import AdminLogin from './components/admin/AdminLogin';
// import Logout from './components/admin/Logout';
// import AdminHome from './components/admin/AdminHome';
// import SetUpTrivia from './components/admin/SetUpTrivia';
// import SetUpQuestions from './components/admin/SetUpQuestions';
// import SetUpRewards from './components/admin/SetUpRewards';
import TriviaBigScreenHorizontal from './components/main_screens/TriviaBigScreenHorizontal';
import TriviaBigScreenVertical from './components/main_screens/TriviaBigScreenVertical';
// import { app } from './base'
import './App.css';


// function AuthenticatedRoute({component: Component, authenticated, ...rest}) {
//     return (
//         <Route
//             {...rest}
//             render={(props) => {
//               if(authenticated === true){
//                 return (
//                   <Component {...props} {...rest} />
//                 )
//               } else {
//                 return (
//                   <Redirect to={{pathname: '/adminLogin', state: {from: props.location}}} />
//                 )
//               }
//               }} />
//     )
// }

class App extends Component {
  constructor(props) {
        super(props)
        // this.setCurrentUser = this.setCurrentUser.bind(this)
        this.state = {
          authenticated: false,
          variables: {},
          // currentUser: null,
          loading: true,
        }
    }

  // setCurrentUser(user) {
  //     if (user) {
  //         this.setState({
  //             currentUser: user,
  //             authenticated: true
  //         })
  //     } else {
  //         this.setState({
  //             currentUser: null,
  //             authenticated: false
  //         })
  //     }
  // }

  componentWillMount() {
    this.tenantVariablesRef = base.listenTo(`tenantVariables`, {
      context: this,
      state: 'tenantVariables',
      then(variables){
        this.setState({
            authenticated: false,
            variables: variables,
            loading: false,
        })
      }
    });
  }

    componentWillUnmount() {
      base.removeBinding(this.tenantVariablesRef);
        // this.removeAuthListener()
    }


  render() {
    if (this.state.loading === true) {
        return (
            <Loading loading={this.state.loading}/>
        )
    }
    return (
      <div style={{ margin: "0 auto"}}>
        <BrowserRouter>
            <div>
                <div className="main-content">
                    <div className="workspace">
                      <Switch>
                        <Route
                          exact
                          path="/login"
                          render={(props) => {
                            return <Login variables={this.state.variables} {...props} />
                          }}
                        />
                        <Route
                          exact
                          path="/bigscreenhorizontal"
                          render={(props) => {
                            return <TriviaBigScreenHorizontal variables={this.state.variables} {...props} />
                          }}
                        />
                        <Route
                          exact
                          path="/bigscreenvertical"
                          render={(props) => {
                            return <TriviaBigScreenVertical variables={this.state.variables} {...props} />
                          }}
                        />
                        <Route
                          exact
                          path="/"
                          render={(props) => {
                            return <MainApp variables={this.state.variables} {...props} />
                          }}
                        />

                        <Redirect to={`/login`}/>
                      </Switch>
                    </div>
                </div>
            </div>
        </BrowserRouter>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js